import type { OrganizationFeature, SsoMode, TwoFactorChannel } from "@/types/organization";

export const FEATURE_OPTIONS: Array<{ value: OrganizationFeature; label: string }> = [
  { value: "q_and_a", label: "Q&A" },
  { value: "reports", label: "Reports" },
  { value: "public_api", label: "Public API" },
  { value: "contract_families", label: "Contract Families" },
  { value: "suppliers", label: "Suppliers" },
  { value: "spend_centre", label: "Spend Centre" },
  { value: "renewal_centre", label: "Renewal Centre" },
  { value: "esg_portal", label: "ESG Portal" },
  { value: "document_authoring", label: "Document Authoring" },
  { value: "open_chat", label: "Open Chat" },
  { value: "sharepoint", label: "SharePoint" },
];

export const DATE_FORMAT_OPTIONS = [
  { value: "US", label: "US: MM/DD/YYYY" },
  { value: "ISO", label: "ISO: YYYY-MM-DD" },
  { value: "UK_EU", label: "UK/EU: DD/MM/YYYY" },
];

export const TIME_FORMAT_OPTIONS = [
  { value: "12h", label: "12-hour (AM/PM)" },
  { value: "24h", label: "24-hour" },
];

export const SSO_MODE_OPTIONS: Array<{ value: SsoMode; label: string; description: string }> = [
  { value: "password", label: "Password only", description: "Traditional email/password login" },
  { value: "both", label: "SSO + Password", description: "Both SSO and password login allowed" },
  { value: "sso", label: "SSO only", description: "Password login disabled, SSO required" },
];

export const TWO_FACTOR_CHANNEL_OPTIONS: Array<{ value: TwoFactorChannel; label: string; description: string }> = [
  { value: "sms", label: "SMS", description: "Send the first 2FA code to the user's phone number" },
  { value: "email", label: "Email", description: "Send the first 2FA code to the user's email address" },
];

export const CUSTOM_MODEL_SELECT_VALUE = "__custom_model__";
export const CUSTOM_MODEL_PATTERN = /^[A-Za-z0-9][A-Za-z0-9._:/-]{0,127}$/;

// Order matters: it defines the render order of the sections and the key order of the submitted payload.
export const STYLE_GUIDE_SECTIONS = [
  {
    key: "styleGuideSection1",
    label: "Section 1: Language and Tone",
    placeholder: "Leave empty to use the default style guide for Language and Tone",
    rows: 6,
  },
  {
    key: "styleGuideSection11",
    label: "Section 11: Style Attributes",
    placeholder: "Leave empty to use the default style guide for Style Attributes",
    rows: 10,
  },
  {
    key: "styleGuideSection19",
    label: "Section 19: Drafting Letters, Notices, and Client Communications",
    placeholder: "No default - only applied when content is provided",
    rows: 6,
  },
  {
    key: "styleGuideSection18",
    label: "Section 18: Company Details",
    placeholder: "No default - only applied when content is provided",
    rows: 6,
  },
] as const;
